import BillingsOrderRelatedTaxiTaxiRequest from "../../../../../api/raily/billings/order/related/taxi-taxi/billings-order-related-taxi-taxi.request";
import BillingsOrderRelatedTaxiTaxiParams from "./billings-order-related-taxi-taxi-params";

const create = (
  params: BillingsOrderRelatedTaxiTaxiParams,
): BillingsOrderRelatedTaxiTaxiRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const billingsOrderRelatedTaxiTaxiParamsFactory = {
  create,
};

export default billingsOrderRelatedTaxiTaxiParamsFactory;
